import { z } from "zod";

export const productSearchItemSchema = z.object({
  catalogListId: z.number().int(),
  nome: z.string().optional(),
  marca: z.string().optional(),
  descrizione: z.string().nullable().optional(),
  prezzoVendita: z.number().nullable().optional(),
  speseDiSpedizione: z.number().nullable().optional(),
  linkOfferta: z.string().nullable().optional(),
  linkImmagine: z.string().nullable().optional(),
  linkImmagine1: z.string().nullable().optional(),
  linkImmagine2: z.string().nullable().optional(),
  vendorId: z.number().int().optional(),
  categoryListId: z.number().int().nullable().optional(),
  disponibilita: z.number().nullable().optional(),
  metodiPagamentoIds: z.array(z.number().int()).optional(),
  certificato: z.boolean().nullable().optional(),
  isDeleted: z.number().int().nullable().optional(),
  isDisattivato: z.number().int().nullable().optional(),
  stato: z.number().int().nullable().optional(),
  isPreferito: z.number().int().nullable().optional(),
  isAlert: z.number().int().nullable().optional(),
  priceAlert: z.number().nullable().optional(),
}).strip();

export const productsSearchResponseSchema = z.object({
  statusCode: z.number().int().optional(),
  products: z.array(productSearchItemSchema).optional().default([]),
  totalsResults: z.number().int().optional(),
  maxNumPage: z.number().int().optional(),
  minPrezzo: z.number().optional(),
  maxPrezzo: z.number().optional(),
  marche: z.array(z.string()).optional(),
  vendors: z.array(z.object({
    vendorId: z.number().int(),
    nomeVendor: z.string().optional(),
  }).strip()).optional(),
}).strip();

export function parseProductsSearchResponse(data) {
  return productsSearchResponseSchema.parse(data);
}
